<template>
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        class="fill-current"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11 21C12.6569 21 14 19.6569 14 18C14 16.3431 12.6569 15 11 15C9.34315 15 8 16.3431 8 18C8 19.6569 9.34315 21 11 21ZM11 23C13.7614 23 16 20.7614 16 18C16 15.2386 13.7614 13 11 13C8.23858 13 6 15.2386 6 18C6 20.7614 8.23858 23 11 23Z"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.397 16.2881C11.5839 16.3655 11.7057 16.5478 11.7057 16.75V19.25C11.7057 19.5262 11.4818 19.75 11.2057 19.75C10.9295 19.75 10.7057 19.5262 10.7057 19.25V17.9571L10.5592 18.1036C10.364 18.2988 10.0474 18.2988 9.85213 18.1036C9.65687 17.9083 9.65687 17.5917 9.85213 17.3965L10.8521 16.3965C10.9951 16.2535 11.2102 16.2107 11.397 16.2881Z"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7 9C8.65685 9 10 7.65685 10 6C10 4.34315 8.65685 3 7 3C5.34315 3 4 4.34315 4 6C4 7.65685 5.34315 9 7 9ZM7 11C9.76142 11 12 8.76142 12 6C12 3.23858 9.76142 1 7 1C4.23858 1 2 3.23858 2 6C2 8.76142 4.23858 11 7 11Z"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.39703 4.28807C7.58387 4.36547 7.70569 4.54778 7.70569 4.75001V7.25001C7.70569 7.52616 7.48183 7.75001 7.20569 7.75001C6.92955 7.75001 6.70569 7.52616 6.70569 7.25001V5.95712L6.55924 6.10357C6.36398 6.29883 6.0474 6.29883 5.85214 6.10357C5.65687 5.90831 5.65687 5.59172 5.85214 5.39646L6.85214 4.39646C6.99513 4.25346 7.21019 4.21068 7.39703 4.28807Z"
        />
        <path
            d="M18.7057 8.75001C18.7057 8.54778 18.5839 8.36547 18.397 8.28807C18.2102 8.21068 17.9951 8.25346 17.8521 8.39646L16.8521 9.39646C16.6569 9.59172 16.6569 9.90831 16.8521 10.1036C17.0474 10.2988 17.364 10.2988 17.5592 10.1036L17.7057 9.95712V11.25C17.7057 11.5262 17.9295 11.75 18.2057 11.75C18.4818 11.75 18.7057 11.5262 18.7057 11.25V8.75001Z"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M23 10C23 12.7614 20.7614 15 18 15C17.7636 15 17.531 14.9836 17.3033 14.9518C16.4816 13.2559 14.9957 11.9417 13.1836 11.3473C13.064 10.9187 13 10.4668 13 10C13 7.23858 15.2386 5 18 5C20.7614 5 23 7.23858 23 10ZM21 10C21 11.6569 19.6569 13 18 13C16.3431 13 15 11.6569 15 10C15 8.34315 16.3431 7 18 7C19.6569 7 21 8.34315 21 10Z"
        />
    </svg>
</template>
